module.exports = __webpack_public_path__ + "static/media/docnew.7fdc880f.svg";